<template>
  <div>
    <el-select
      :style="styles"
      v-model="val"
      filterable
      :multiple="multiple"
      :placeholder="placeholder"
      clearable
      @clear="handlerClear"
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
      />
    </el-select>
  </div>
</template>

<script>
  import { getStationList } from '@/api/public'
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComStationSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择站点'
      },
      styles: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        val: undefined,
        options: []
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await getStationList({ includeDel: this.showDelete })
        if (code !== 0) {
          return
        }
        const records = data
        if (!Array.isArray(records)) {
          return
        }
        const l = records.map((item) => {
          const obj = {
            value: item.stationId + '',
            label: item.stationName,
            ...item
          }
          return obj
        })
        this.options = l
      },
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      },
      handlerClear() {
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="scss" scoped></style>
